import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'
import { elevatedSurfaceBoxShadow } from '../../../shared/style-settings'

export const usePageWrapperStyles = makeStyles((theme: Theme) =>
  createStyles({
    profilePage: {
      position: 'relative',
      background: theme.palette.background.paper,
      padding: theme.spacing(4, 4, 6, 4),
      borderRadius: theme.shape.borderRadius * 3,
      boxShadow: elevatedSurfaceBoxShadow,
      border: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3, 2, 4, 2),
        borderRadius: theme.shape.borderRadius * 2,
      },
      // Page title styles
      '& h1, & h2': {
        fontWeight: 700,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(3),
      },
      '& h2': {
        fontSize: '1.5rem',
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.25rem',
        },
      },
      // Form improvements
      '& .MuiFormControl-root': {
        marginBottom: theme.spacing(2),
      },
      '& .MuiOutlinedInput-root': {
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
          },
        },
      },
      // Alert improvements
      '& .MuiAlert-root': {
        borderRadius: theme.shape.borderRadius * 2,
      },
    },
    pageHolder: {
      position: 'relative',
    },
  })
)
